import { useQuery } from '@tanstack/react-query';

import { getDirectTaskRelations } from '@/lib/api/generated/api';
import { expectStatus } from '@/lib/api/client';
import type { DirectTaskRelationsResponse } from '@/lib/api/generated/model';
import { taskRelationsKeys } from '../queryKeys';

/** A task's own direct relations, with their edge ids (068, research D6). */
export function useDirectTaskRelations(workspaceId: string, taskId: string) {
  return useQuery({
    queryKey: taskRelationsKeys.direct(workspaceId, taskId),
    queryFn: async (): Promise<DirectTaskRelationsResponse> =>
      expectStatus(
        await getDirectTaskRelations(workspaceId, taskId),
        200,
        "This task's relations could not be loaded.",
      ),
  });
}
